import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY, breakpoints} from "@next/ux-fabric"
import Grid from "@mui/material/Grid"

export const BannerContainer = styled("div")`
    display: flex;
    align-items: center;
    height: 1.5rem;
    background-color: ${({theme}) => theme.uxfabric.components.appBar.backToNext.default.backgroundColor};
    padding-left: 2.5rem;
    max-width: ${breakpoints.values.xl}px;
    width: 100%;
    @media (max-width: ${breakpoints.values.md}px) {
        padding-left: 0.8rem;
    }
`
export const BannerBackToSite = styled("div")`
    cursor: pointer;
    display: flex;
    align-items: center;
`
export const TextWrapper = styled("div")`
    color: ${({theme}) => theme.uxfabric.components.appBar.backToNext.default.textColor};
    font-size: 0.563rem;
    padding: 0 0.5rem;
    font-size: ${({theme}) => theme.uxfabric.global.body2.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.global.body2.fontWeight};
    letter-spacing: ${({theme}) => theme.uxfabric.global.body2.letterSpacing};
    line-height: ${({theme}) => theme.uxfabric.global.body2.lineHeight};
    font-family: ${({theme}) => `${theme.uxfabric.global.body2.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    align-items: center;
`

export const Logo = styled("img")`
    height: 0.75rem;
    filter: invert(1);
`

export const BrandTextGrid = styled(Grid)`
    display: flex;
    justify-content: center;
`

export const CloseButtonGrid = styled(Grid)`
    display: flex;
    justify-content: flex-end;
`
export const BannerWrapper = styled("div")`
    background-color: ${({theme}) => theme.uxfabric.components.appBar.backToNext.default.backgroundColor};
    display: flex;
    height: 1.5rem;
    flex: 1 1 0;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    align-items: center;
    justify-content: center;
`
